import { useSelector } from 'react-redux';
import { useMemo } from 'react';
import { GreenroomState as GS } from '../../stores/types/types';


const mapFunc = (dev: MediaDeviceInfo) => ({
	label: dev.label,
	value: dev.deviceId,
	className: 'truncate-overflow',
});

const getSelected = (
	devices: MediaDeviceInfo[],
	selected: MediaDeviceInfo | null,
	label: string,
) => {
    const doesExist = devices.find((d) => d.deviceId === selected?.deviceId || d.label === selected?.label);
    if (!doesExist) {
        return { label: `Cannot access ${label}`, value: '' };
    }
	return { label: selected?.label || '', value: selected?.deviceId };
}

export const useDeviceList = () => {
    // this is a hook to format the device lists for the select drop down components
    const videoDevices = useSelector((s: GS) => s.VideoReducer.videoDevices);
	const audioDevices = useSelector((s: GS) => s.VideoReducer.audioDevices);
	const audioOutputs = useSelector((s: GS) => s.VideoReducer.audioOutputs);
	const selectedVideo = useSelector((s: GS) => s.VideoReducer.selectedVideo);
	const selectedAudio = useSelector((s: GS) => s.VideoReducer.selectedAudio);
	const selectedOutput = useSelector((s: GS) => s.VideoReducer.selectedOutput);

    const videoOpts = useMemo(() => videoDevices.map(mapFunc), [videoDevices]);
	const micOpts = useMemo(() => audioDevices.map(mapFunc), [audioDevices]);
	const outputOpts = useMemo(() => audioOutputs.map(mapFunc), [audioOutputs]);

	const selectedVideoOption = useMemo(
		() => getSelected(videoDevices, selectedVideo, 'camera'),
		[selectedVideo, videoDevices]
	);
	
	const selectedMicOption = useMemo(
		() => getSelected(audioDevices, selectedAudio, 'microphone'),
		[selectedAudio, audioDevices]
	);
	
	const selectedOutputOption = useMemo(
		() => getSelected(audioOutputs, selectedOutput, 'speakers'),
		[selectedOutput, audioOutputs]
	);
	
    return {
        videoOpts,
        micOpts,
        outputOpts,
        selectedVideoOption,
        selectedMicOption,
        selectedOutputOption
    };
};

export default useDeviceList;
